import { useState } from "react";
import { Container } from "./Container";
import { ConfirmationContainer } from "./ConfirmationContainer";

export default function App() {
	const [isValidEmail, setIsValidEmail] = useState(true);
	const [input, setInput] = useState("");
	return (
		<div className="App">
			<Container
				isValidEmail={isValidEmail}
				setIsValidEmail={setIsValidEmail}
				input={input}
				setInput={setInput}
			/>
			<ConfirmationContainer isValidEmail={isValidEmail} input={input} />
		</div>
	);
}
